import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import './App.css';
import Main from './Main';
import SignIn from './SignIn';
import SignUpFlow from './SignUp';
import Landing from './Landing';
import Docs from './Docs';
import Agent from './Agent';

import { AuthProvider } from './common/Auth';
import AuthRoute from './common/AuthRoute';

import { CurrentSystemProvider } from './context/SystemContext';
import { ThemeProvider } from './context/ThemeContext';
import Admin from './Admin';

function App() {

  const [currentSystem, setCurrentSystem] = useState({});
  const [editSystem, setEditSystem] = useState(false);

  const createNewSystem = async () => {
    console.log("New System");
    const system = { name: "New System", type: "Default" };
    // getSystems();
  }

  const getSystems = async () => {
    //const sys =  await API.graphql(graphqlOperation(query.listSystems, {limit: 100}));
    //setSystems(sys.data.listSystems.items);
  }

  const setSystem = (system) => {
    setCurrentSystem(system);
  }

  const doDeleteSystem = (system) => {
    var sysid = { id: system.id };
    //API.graphql(graphqlOperation( deleteSystem, { input: sysid })).then(
    getSystems();
    // );
  }

  const doEditSystem = (system) => {
    setCurrentSystem(system);
    setEditSystem(true);
  }

  const endEditSystem = () => {
    setEditSystem(false);
  }

  return (
    <div className="App min-h-screen bg-background text-foreground">
      <ThemeProvider>
        <AuthProvider>
          <CurrentSystemProvider>
            <Router>
              <Switch>
                <AuthRoute path="/app" component={Main} />
                <Route exact path="/login" component={SignIn} />
                <Route exact path="/signup" component={SignUpFlow} />
                <Route exact path="/docs" component={Docs} />
                <Route path="/" component={Landing} />
              </Switch>
            </Router>
          </CurrentSystemProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
